const SUPABASE_URL = process.env.REACT_APP_BO_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_BO_SUPABASE_ANON_KEY;

export async function callEdge(fn, body) {
  const res = await fetch(`${SUPABASE_URL}/functions/v1/${fn}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Error ${res.status} en ${fn}`);
  }
  return res.json();
}

export { SUPABASE_URL, SUPABASE_ANON_KEY };
